import SpriteSymbol from "../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "cancelIcon",
  "use": "cancelIcon-usage",
  "viewBox": "0 0 14 15",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 15\" fill=\"none\" id=\"cancelIcon\">\n<circle cx=\"7\" cy=\"7.5\" r=\"6.4\" stroke=\"currentColor\" stroke-width=\"1.2\" />\n<path d=\"M4.35357 10.8536L10.3536 4.85355L9.64645 4.14645L3.64647 10.1464L4.35357 10.8536ZM10.3535 10.1464L4.35355 4.14645L3.64645 4.85355L9.64643 10.8536L10.3535 10.1464Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol